export default {"src":"/_next/static/media/faq-icon9.e0c93af9.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};